import Image from 'next/image';
import { ClueCard } from '@snapi/luxury';

import BabyImage from './images/baby.png';
import YellowCircle from './images/yellow-circle.png';
import BacteriaFeet from './images/bacteria-feet.png';

export function WhatSectionScience() {
  return (
    <section className="relative flex flex-col overflow-x-hidden">
      <div className="container flex flex-col items-center sm:flex-row sm:items-start sm:pl-5 md:pl-7 lg:justify-between">
        <div className="relative px-8 sm:order-2 sm:px-2">
          <div className="min-w-[260px] sm:w-[260px] xl:w-[436px]">
            <Image src={BabyImage} alt=" " />
          </div>
          <div
            className="
                absolute bottom-[-40px] right-[-70px] w-[216px]
                 sm:right-[-110px] lg:right-[-90px] 
                 xl:bottom-[30px] xl:right-[-30px]"
          >
            <Image src={YellowCircle} alt=" " />
          </div>
        </div>
        <div className="mb-5 sm:mt-8 md:mt-10 sm:order-1 sm:mb-20 lg:mt-14 xl:mt-28">
          <div className="flex items-end relative w-[220px] mb-3 sm:w-[340px] md:w-[360px] lg:w-[410px] xl:w-[460px]">
            <h2>What is microbiome?</h2>
            <div className="text-center w-[200px] sm:w-[226px] text-[24px] mb-[6px] absolute right-[-90px] sm:right-[-100px] md:right-[-120px] lg:right-[-80px] xl:right-[-30px]">
              <ClueCard
                description="Defining the human microbiome."
                href="https://doi.org/10.1111/j.1753-4887.2012.00493.x"
                orientation="bottom"
              />
            </div>
          </div>
          <div className='className="sm:min-w-[342px] md:min-w-[444px] lg:w-[608px] xl:max-w-[514px] flex flex-col gap-2 text-body'>
            <p>
              Microbiome is defined as the community of microorganisms that consists of 
              protective, neutral, and disruptive bacteria. These bacteria are involved in 
              the digestion of nutrients, development and function of the immune system, and 
              protection against diseases and infections.
            </p>
            <p>
              The human microbiome is a newly explored yet extremely important component 
              of our health. In recent years, the microbiome located in the intestinal tract 
              of our guts has been shown to play a crucial role in health.
            </p>
          </div>
        </div>
      </div>
      <div className="lg:h-[140px] xl:h-[50px]">
        <div
          className="w-[140px] mx-auto sm:absolute sm:bottom-[50px] sm:right-[150px]
           md:w-[160px] md:right-[170px] lg:w-[216px] lg:bottom-[100px] lg:right-0 lg:left-[320px] 
           xl:left-0 xl:bottom-[70px]
              "
        >
          <Image src={BacteriaFeet} alt=" " />
        </div>
      </div>
    </section>
  );
}
